import React from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonBackButton,
  IonButtons,
} from '@ionic/react';
import { useTranslation } from 'react-i18next';

// Keep in step with public/privacy.html (the page Google and the website read)
const PrivacyPolicy: React.FC = () => {
  const { t } = useTranslation();
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/login" />
          </IonButtons>
          <IonTitle>{t('pages.PrivacyPolicy.privacyPolicy')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <h2>{t('pages.PrivacyPolicy.privacyPolicy')}</h2>
        <p style={{ color: '#888', fontSize: '0.85rem' }}>{t('pages.PrivacyPolicy.lastUpdatedOctober262026')}</p>

        <p>{t('pages.PrivacyPolicy.rSMaidsWeOurOr2')}</p>

        <h3>{t('pages.PrivacyPolicy.1InformationWeCollect')}</h3>
        <p><strong>{t('pages.PrivacyPolicy.staffAndManagementAccounts')}</strong></p>
        <ul>
          <li><strong>{t('pages.PrivacyPolicy.accountInformation')}</strong>{t('pages.PrivacyPolicy.nameEmailAddressPhoneNumberProfile')}</li>
          <li><strong>{t('pages.PrivacyPolicy.workInformation')}</strong>{t('pages.PrivacyPolicy.jobAssignmentsSchedulesAvailabilityTimeA')}</li>
          <li><strong>{t('pages.PrivacyPolicy.deviceInformation')}</strong>{t('pages.PrivacyPolicy.aPushNotificationTokenSoWe')}</li>
        </ul>
        <p><strong>{t('pages.PrivacyPolicy.clients')}</strong></p>
        <ul>
          <li><strong>{t('pages.PrivacyPolicy.contactInformation')}</strong>{t('pages.PrivacyPolicy.nameEmailAddressPhoneNumberAnd')}</li>
          <li><strong>{t('pages.PrivacyPolicy.bookingInformation')}</strong>{t('pages.PrivacyPolicy.theServicesYouBookedAppointmentDates')}</li>
          <li><strong>{t('pages.PrivacyPolicy.messagesAndCalls')}</strong>{t('pages.PrivacyPolicy.textMessagesEmailsChatMessagesPhotos')}</li>
          <li><strong>{t('pages.PrivacyPolicy.billingInformation')}</strong>{t('pages.PrivacyPolicy.invoicesPaymentAmountsAndPaymentStatus')}</li>
        </ul>
        <p><strong>{t('pages.PrivacyPolicy.googleCalendarDataOptional')}</strong></p>
        <ul>
          <li>{t('pages.PrivacyPolicy.ifAStaffMemberChoosesTo')}</li>
        </ul>

        <h3>{t('pages.PrivacyPolicy.2HowWeUseYourInformation')}</h3>
        <ul>
          <li>{t('pages.PrivacyPolicy.toScheduleAssignAndCompleteCleaning')}</li>
          <li>{t('pages.PrivacyPolicy.toDisplayYourScheduleAndCalendar')}</li>
          <li>{t('pages.PrivacyPolicy.toSendBookingConfirmationsRemindersMessa')}</li>
          <li>{t('pages.PrivacyPolicy.toTakeAndRecordPaymentsAnd')}</li>
          <li>{t('pages.PrivacyPolicy.toAnswerCallsTextsAndMessages')}</li>
          <li>{t('pages.PrivacyPolicy.toSecureAccountsPreventFraudAnd')}</li>
          <li>{t('pages.PrivacyPolicy.weDo')} <strong>{t('pages.PrivacyPolicy.not')}</strong>{t('pages.PrivacyPolicy.sellYourPersonalDataAndWe')}</li>
        </ul>

        <h3>{t('pages.PrivacyPolicy.3GoogleUserData')}</h3>
        <p>{t('pages.PrivacyPolicy.ourAppCanUseTheGoogle')}</p>
        <p>{t('pages.PrivacyPolicy.youMayRevokeAccessAtAny')}</p>
        <p>{t('pages.PrivacyPolicy.ourUseAndTransferOfInformation')}</p>

        <h3>{t('pages.PrivacyPolicy.4WhoWeShareInformationWith')}</h3>
        <p>{t('pages.PrivacyPolicy.weSharePersonalDataOnlyWith')}</p>
        <ul>
          <li><strong>{t('pages.PrivacyPolicy.googleFirebase')}</strong>{t('pages.PrivacyPolicy.signInDatabaseFileStorageHosting')}</li>
          <li><strong>{t('pages.PrivacyPolicy.wix')}</strong>{t('pages.PrivacyPolicy.ourWebsiteOnlineBookingClientContact')}</li>
          <li><strong>{t('pages.PrivacyPolicy.twilio')}</strong>{t('pages.PrivacyPolicy.phoneCallsVoicemailAndTextMessages')}</li>
          <li><strong>{t('pages.PrivacyPolicy.helcim')}</strong>{t('pages.PrivacyPolicy.paymentCardProcessing')}</li>
          <li><strong>{t('pages.PrivacyPolicy.zohoBooks')}</strong>{t('pages.PrivacyPolicy.invoicingAndAccounting')}</li>
          <li><strong>{t('pages.PrivacyPolicy.emailDeliveryProviders')}</strong>{t('pages.PrivacyPolicy.sendingTheEmailsDescribedAbove')}</li>
          <li><strong>{t('pages.PrivacyPolicy.googleCalendar')}</strong>{t('pages.PrivacyPolicy.onlyForStaffWhoChooseTo')}</li>
        </ul>
        <p>{t('pages.PrivacyPolicy.weMayAlsoDiscloseInformationIf')}</p>

        <h3>{t('pages.PrivacyPolicy.5DataRetention')}</h3>
        <p>{t('pages.PrivacyPolicy.weKeepPersonalDataForAs')}</p>

        <h3>{t('pages.PrivacyPolicy.6YourChoicesAndRights')}</h3>
        <ul>
          <li>{t('pages.PrivacyPolicy.youCanAskUsToAccess')}</li>
          <li>{t('pages.PrivacyPolicy.youCanTurnOffPushNotifications')}</li>
          <li>{t('pages.PrivacyPolicy.youCanReplyStopToAny')}</li>
        </ul>

        <h3>{t('pages.PrivacyPolicy.7Security')}</h3>
        <p>{t('pages.PrivacyPolicy.weUseIndustryStandardSafeguardsIncluding')}</p>

        <h3>{t('pages.PrivacyPolicy.8Children')}</h3>
        <p>{t('pages.PrivacyPolicy.theServiceIsNotDirectedTo')}</p>

        <h3>{t('pages.PrivacyPolicy.9ChangesToThisPolicy')}</h3>
        <p>{t('pages.PrivacyPolicy.weMayUpdateThisPolicyFrom')}</p>

        <h3>{t('pages.PrivacyPolicy.10ContactUs')}</h3>
        <p>{t('pages.PrivacyPolicy.ifYouHaveAnyQuestionsAbout2')} <strong>{t('pages.PrivacyPolicy.supportRsmaidsserviceNet')}</strong></p>
      </IonContent>
    </IonPage>
  );
};

export default PrivacyPolicy;
